import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'riderName'
})
export class RiderNamePipe implements PipeTransform {

  transform(riderArray: any[], nameMap: any = {}, boardingType: string): any {
    const riderNames = [];
    riderArray.forEach((rider) => {
      if (rider.name && (!boardingType || (boardingType && boardingType === rider.boardingType))) {
        riderNames.push(nameMap ? nameMap[rider.name + "(" + rider.mobile + ")"] : rider.name + "(" + rider.mobile + ")");
      }
    });
    return riderNames.length ? riderNames.join(' | ') : '--';
  }

}
